import { gql } from '@apollo/client';

export const GET_CHATBOT_SECTION_SCHEMAS = gql`
  query ChatbotSectionSchemas($params: FindChatbotSectionRelationInput!) {
    chatbotSectionSchemas(params: $params) {
      success
      message
      errors
      data {
        id
        entity
        description
        triggerKeywords
        maxResultsWithoutClarification
        type
        matchEntities
        relatedEntities
        finalQueryTemplate
        personKeywords
        parentSchemaId
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
    }
  }
`;

export const GET_CHATBOT_DOCUMENTS = gql`
  query ChatbotDocuments($params: FindDocumentListInput!) {
    chatbotDocuments(params: $params) {
      success
      message
      errors
      data {
        documents {
          id
          tenantId
          userId
          fileName
          originalFileName
          fileSize
          mimeType
          path
          uri
          description
          tags
          docMetadata
          documentTypeId
          createdAt
          createdBy
        }
        hasMorePages
        nextPage
        totalPages
        totalRecords
      }
    }
  }
`;

export const GET_CHATBOT_SECTION_DOCUMENTS = gql`
  query ChatbotSectionDocuments($params: FindChatbotSectionRelationInput!) {
    chatbotSectionDocuments(params: $params) {
      success
      message
      errors
      data {
        id
        tenantId
        userId
        fileName
        originalFileName
        fileSize
        mimeType
        path
        uri
        description
        tags
        docMetadata
        documentTypeId
        createdAt
        createdBy
      }
    }
  }
`;

export const GET_CHATBOT_SECTION_NODES = gql`
  query ChatbotSectionNodes($params: FindChatbotSectionRelationInput!) {
    chatbotSectionNodes(params: $params) {
      success
      message
      errors
      data {
        id
        code
        name
        keywords
        semanticWeight
        order
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
    }
  }
`;
